import { CircuitFormData } from '@/types/circuits/CircuitFormData';
import { getCircuitBenefitFirstDay } from '../getCircuitBenefitFirstDay';

export const getCircuitDaysWithMultiDayBenefitTracking = <
  T extends { steps: CircuitFormData['circuitDays'][number]['steps'] },
>(
  circuitDays: T[],
) =>
  circuitDays.map((day) => ({
    ...day,
    steps: day.steps.map((step) => ({
      ...step,
      transport: {
        ...step.transport,
        standardBenefit: step.transport?.standardBenefit
          ? {
              ...step.transport?.standardBenefit,
              indexFirstDay: step.transport
                ? getCircuitBenefitFirstDay(circuitDays, step.transport)
                : undefined,
            }
          : undefined,
        optionalBenefits: step.transport?.optionalBenefits?.map((benefit) => ({
          ...benefit,
          indexFirstDay: step.transport
            ? getCircuitBenefitFirstDay(circuitDays, step.transport)
            : undefined,
        })),
      },
      accommodations: {
        ...step.accommodations,
        standardBenefit: step.accommodations?.standardBenefit
          ? {
              ...step.accommodations?.standardBenefit,
              indexFirstDay: step.accommodations
                ? getCircuitBenefitFirstDay(circuitDays, step.accommodations)
                : undefined,
            }
          : undefined,
        optionalBenefits: step.accommodations?.optionalBenefits?.map(
          (benefit) => ({
            ...benefit,
            indexFirstDay: step.accommodations
              ? getCircuitBenefitFirstDay(circuitDays, step.accommodations)
              : undefined,
          }),
        ),
      },
    })),
  }));
